import actions from '../../../actions';
import { getUniqueDeviceId } from '../../../services/device';
import { storage } from '../../../services/localstorage';
import { PARTS_DELIMITER } from '../fileNameUtil';

export const BACKUP_FILE_NAME = 'aimdbackup';
export const DEVICE_FILE_NAME = 'devices.json';

export const USE_GOOGLE_METADATA_INFO = false;
export const USE_ATTACHMENTS = true;

export const autoBackup = {
    started: false,
    error: false,
    success: false,
};

export const backupInfoProcessing = {
    interactive: true,
    disableInteractive: false,
    disableBackup: false,
};

export const getDeviceId = async () => {
    let devId; // = await storage.get('devId');
    devId = (await getUniqueDeviceId(false)) ?? 'unknown';
    if (!devId) {
        await storage.set('devId', devId);
    }
    devId = devId.replace(/_/g, '~');
    return devId;
};

export const getFileName = async (profileId, isPending) => {
    const deviceId = await getDeviceId();
    if (profileId) {
        return `${isPending ? `pending${PARTS_DELIMITER}` : ''}${BACKUP_FILE_NAME}${PARTS_DELIMITER}${deviceId ?? 'unknown'}${PARTS_DELIMITER}${profileId}.json`;
    }

    return null;
};

export const getAttachFileName = (profileId, attachmentId) => {
    if (profileId && (attachmentId || attachmentId === '')) {
        return `attach${PARTS_DELIMITER}${profileId}${PARTS_DELIMITER}${attachmentId}`;
    }

    return null;
};

export const toLog = (name, ...params) => {
    // noinspection JSUnresolvedReference
    actions.addLog(`${name}`, params);
    const isError = name?.indexOf('error') >= 0 || name?.indexOf('Error') >= 0;
    if (isError) {
        console.error(`%c${name}`, 'color: #880022', ...params);

    } else {
        console.log(`%c${name}`, 'color: #009922', ...params);
    }
};
